import 'bootstrap/dist/css/bootstrap.min.css'
import NavBar from './components/NavBar'
import Banner from './components/Banner'
import About from './components/About'
import Skills from './components/Skills'
import Projects from './components/Projects'


function App() {
  return (
    <div>
      <NavBar />
      <Banner />
      <Skills />
      <Projects />
      <About />
    </div>
  );
}

export default App;
